import { useQuery } from "@tanstack/react-query";
import { SbBlokData } from "@storyblok/react";

import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";
import { CONFIG } from "@lib/config";
import { languageDutch } from "../i18n";

export interface Notification {
  id: string;
  slug: string;
  title: string;
  category: string;
  description: string;
  body?: SbBlokData[] | [];
  createdAt: number;
  audience: string[];
  isRead: boolean;
  isDeleted: boolean;
  link?: string;
}

export type NotificationData = Notification[];

export const QUERY_KEY = "getNotifications";

export const useGetNotifications = (params: {
  language: string | undefined;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY, params.language || languageDutch],
    queryFn: async (): Promise<NotificationData> => {
      const response = await apiClient.get<NotificationData>(
        API_ROUTES.notifications,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            language: params.language,
          },
        }
      );
      return response.data;
    },
    refetchInterval: Number(CONFIG.NOTIFICATION_REFRESH_INTERVAL),
  });
};
